import React from 'react';
import LeftSection from './LeftSection';
import RightSection from './RightSection';

const Profile = () => {
  return (
    <div className='flex items-start gap-[4px] w-full h-full'>
      <div className='overflow-y-scroll h-[100%] max-h-[95%] w-[23%] rounded-[32px]' style={{ background: `linear-gradient(180deg, rgba(252, 245, 82, 0.50) 0%, rgba(252, 245, 82, 0.00) 100%), rgba(250, 250, 250, 0.20)`}}>
        <LeftSection />
      </div>
      <div className='overflow-y-scroll h-[100%] max-h-[95%] w-[77%]'>
        <RightSection />
      </div>
    </div>
  )
}

export default Profile